import { render } from "./PlaceOrder.vue?vue&type=template&id=2882a62e&scoped=true&ts=true"
import script from "./PlaceOrder.vue?vue&type=script&lang=ts"
export * from "./PlaceOrder.vue?vue&type=script&lang=ts"

import "./PlaceOrder.vue?vue&type=style&index=0&id=2882a62e&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\wallet\\wallet-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2882a62e"]])

export default __exports__